import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminLayout from "../../layouts/AdminLayout";
import api, { API_BASE_URL, fetchData } from "../../api/api";
import Spinner from "../../components/common/Spinner";
import { AuthContext } from "../../context/AuthContext";
import { encryptData } from "../../utils/encryptDecrypt";
import { toast } from "react-toastify";
import { CONSTANT_REDIRECT_TIME } from "../../constant/common";
import { getInitials, getPracticeMapUrl } from "../../utils/helper";

const AdminHomePage = () => {
  const { user } = useContext(AuthContext);

  const navigate = useNavigate();

  const didFetch = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  const [practicesList, setPracticesList] = useState([]);

  const [isDelete, setIsDelete] = useState(false);

  const [isStatus, setIsStatus] = useState(false);

  const [isBillingModel, setIsBillingModel] = useState(false);

  const [selectedPractices, setSelectedPractices] = useState(null);

  const [openIndex, setOpenIndex] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);

  const toggleRow = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const getPractices = async () => {
    setIsLoading(true);
    try {
      const data = await fetchData("/get-practices", {
        fk_users_id: user?.users_id,
      });
      setPracticesList(data);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!didFetch.current) {
      getPractices();
      didFetch.current = true;
    }
  }, []);

  if (isLoading) {
    return <Spinner adminLayout={true} />;
  }

  const itemsPerPage = 10;

  const totalPages = Math.ceil(practicesList.length / itemsPerPage);

  const paginatedData =
    practicesList?.length > 0
      ? practicesList.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : [];

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
      setOpenIndex(null);
    }
  };

  const handleDelete = async () => {
    const payload = {
      practices_id: selectedPractices?.practices_id,
    };
    try {
      const response = await api.post("delete-practices", payload);

      if (response?.data?.status === true) {
        toast.success(response.data?.message);

        setTimeout(() => {
          getPractices();
        }, CONSTANT_REDIRECT_TIME);
      } else {
        toast.error(response?.data?.message || "Failed to delete practice.");
        return null;
      }
    } catch (error) {
      console.error("Error delete practice:", error);
      toast.error("Something went wrong. Please try again.");
      return null;
    }
    setSelectedPractices(null);
    setIsDelete(false);
  };

  const handleStatusChange = async () => {
    const payload = {
      practices_id: selectedPractices?.practices_id,
    };
    try {
      const response = await api.post("status-practices", payload);

      if (response?.data?.status === true) {
        toast.success(response.data?.message);

        setSelectedPractices(null);
        setIsStatus(false);

        setTimeout(() => {
          getPractices();
        }, CONSTANT_REDIRECT_TIME);
      } else {
        toast.error(response?.data?.message || "Failed .");
        setIsStatus(false);

        return null;
      }
    } catch (error) {
      setIsStatus(false);
      console.error("Error :", error);
      toast.error("Something went wrong. Please try again.");
      return null;
    } finally {
    }
  };

  const handleAddListingClick = () => {
    if (
      user?.current_plan?.pricing_plan_id === 1 &&
      practicesList?.length > 0
    ) {
      setIsBillingModel(true);

      // setTimeout(() => {
      // navigate("/admin/billing");
      // }, 3000);
    } else {
      navigate("/admin/practices-add");
    }
  };

  return (
    <>
      <AdminLayout>
        <main className="">
          <div className="px-4 py-4 sm:px-8 sm:py-6 md:px-12 md:py-7 flex justify-between gap-4 items-center">
            <h1 className="font-semibold text-lg sm:text-2xl">
              Practice & Practitioners Listing
            </h1>
            {/* <Link to={'/admin/practices-add'} className="py-3 px-4 sm:px-8 border-green  border-2 border-solid bg-green text-white rounded-[8px] font-medium sm:font-semibold text-sm sm:text-base leading-none text-center text-nowrap">+ Add Listing</Link> */}
            <button
              onClick={handleAddListingClick}
              type="button"
              className="py-3 px-4 sm:px-8 border-green  border-2 border-solid bg-green text-white rounded-[8px] font-medium sm:font-semibold text-sm sm:text-base leading-none text-center text-nowrap"
            >
              + Add Listing
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-lightblue">
                <tr>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start w-[54px]"></th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-[67px] sm:min-w-[90px] w-[90px]">
                    Photo
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-48">
                    Practice Name
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-48">
                    Category
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-48">
                    Address
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-[90px] sm:w-[134px]">
                    Listing Plan
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-[90px] sm:w-[134px]">
                    Reviews
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-[90px] sm:w-[134px]">
                    Enquiries
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start ">
                    Status
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start ">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData?.length > 0 ? (
                  paginatedData?.map((practice, index) => (
                    <React.Fragment key={index}>
                      <tr key={index * 2} className="Practice-table-row">
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <button
                            onClick={() => toggleRow(index)}
                            className={`flex items-center justify-center w-full practice-table-btn ${
                              openIndex === index ? "active" : ""
                            }`}
                          >
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="dropicon"
                            >
                              <path
                                d="M15.3136 17.744L26.4952 6.5625L29.6899 9.75722L15.3136 24.1335L0.9375 9.75722L4.1322 6.5625L15.3136 17.744Z"
                                fill="#0052CC"
                              />
                            </svg>
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="plus"
                            >
                              <path
                                d="M1.66667 0H28.3333C29.2538 0 30 0.7462 30 1.66667V28.3333C30 29.2538 29.2538 30 28.3333 30H1.66667C0.7462 30 0 29.2538 0 28.3333V1.66667C0 0.7462 0.7462 0 1.66667 0ZM13.3333 13.3333H6.66667V16.6667H13.3333V23.3333H16.6667V16.6667H23.3333V13.3333H16.6667V6.66667H13.3333V13.3333Z"
                                fill="#0052CC"
                              />
                            </svg>
                          </button>
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          {practice.image ? (
                            <img
                              src={
                                practice.image
                                  ? API_BASE_URL + practice.image
                                  : null
                              }
                              alt=""
                              srcSet=""
                              className="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px] rounded"
                            />
                          ) : (
                            <div className="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px] rounded bg-gray-200 flex items-center justify-center text-lg overflow-hidden font-semibold text-gray-700">
                              {getInitials(practice?.practice_name)}
                            </div>
                          )}
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          {practice?.practice_name}
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <span className="text-dark text-base font-medium">
                            {(() => {
                              const serviceNames = practice?.services
                                ?.map((service) => service.name)
                                .join(", ");
                              return serviceNames.length > 50
                                ? serviceNames.slice(0, 50) + "..."
                                : serviceNames;
                            })()}
                          </span>
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          {practice?.address && (
                            <Link
                              to={getPracticeMapUrl(practice)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-dark text-base font-medium underline underline-offset-2"
                            >
                              {practice?.address}, {practice?.suburb?.name}{" "}
                              {practice?.state?.name}{" "}
                              {practice?.postcode?.postcode}
                            </Link>
                          )}
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <span className="text-center text-base font-medium text-dark rounded-full block p-1 bg-[#FBFB87] max-w-[110px] w-full">
                            {practice?.pricing_plan?.name}
                          </span>
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <Link
                            to={`/admin/reviews/${encryptData(
                              practice?.practices_id
                            )}`}
                            className="text-center text-base font-medium text-dark rounded-full block p-1 bg-[#FBFB87] max-w-[110px] w-full"
                          >
                            {practice?.reviews_count}
                          </Link>
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <Link
                            to={`/admin/enquiries/${encryptData(
                              practice?.practices_id
                            )}`}
                            className="text-center text-base font-medium text-dark rounded-full block p-1 bg-[#FBFB87] max-w-[110px] w-full"
                          >
                            {practice?.total_enquiries_count}
                          </Link>
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <label
                            className="inline-flex items-center me-5 cursor-pointer"
                            onClick={() => {
                              setIsStatus(true);
                              setSelectedPractices(practice);
                            }}
                          >
                            <input
                              type="checkbox"
                              value=""
                              className="sr-only peer hidden"
                              checked={practice?.status === 1}
                              id="toggleSwitch"
                            />
                            <div className="relative w-12 h-7 bg-red-50 border-2 border-red-500 rounded-full peer peer-checked:border-green peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-red-500 peer-checked:after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green"></div>
                          </label>
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <div
                            className="flex rounded-full shadow-xs bg-blue max-w-[144px] w-full"
                            role="group"
                          >
                            <Link
                              title="Edit"
                              to={`/admin/practices-edit/${encryptData(
                                practice?.practices_id
                              )}`}
                              className="pl-5 pr-2 py-2 text-sm font-medium bg-transparent rounded-s-full"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 18.89H6.41421L15.7279 9.57628L14.3137 8.16207L5 17.4758V18.89ZM21 20.89H3V16.6473L16.435 3.21232C16.8256 2.8218 17.4587 2.8218 17.8492 3.21232L20.6777 6.04075C21.0682 6.43127 21.0682 7.06444 20.6777 7.45496L9.24264 18.89H21V20.89ZM15.7279 6.74786L17.1421 8.16207L18.5563 6.74786L17.1421 5.33364L15.7279 6.74786Z"
                                  fill="white"
                                ></path>
                              </svg>
                            </Link>
                            <Link
                              target="_blank"
                              title="Preview"
                              to={`/admin/practices-details/${encryptData(
                                practice?.practices_id
                              )}`}
                              className="px-2 py-2 text-sm font-medium  bg-transparent rounded-s-full"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="#fff"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 7.3125C9.41527 7.3125 7.3125 9.41531 7.3125 12C7.3125 14.5847 9.41527 16.6875 12 16.6875C14.5847 16.6875 16.6875 14.5847 16.6875 12C16.6875 9.41531 14.5847 7.3125 12 7.3125ZM12 14.8125C10.4492 14.8125 9.1875 13.5508 9.1875 12C9.1875 10.4492 10.4492 9.1875 12 9.1875C13.5508 9.1875 14.8125 10.4492 14.8125 12C14.8125 13.5508 13.5508 14.8125 12 14.8125Z"
                                  fill="#fff"
                                />
                                <path
                                  d="M23.691 11.5042C22.7717 10.0288 18.0932 3.5625 12 3.5625C5.90812 3.5625 1.22841 10.0287 0.308953 11.5042L0 12L0.308953 12.4958C1.22831 13.9712 5.90677 20.4375 12 20.4375C18.0919 20.4375 22.7716 13.9713 23.691 12.4958L24 12L23.691 11.5042ZM12 18.5625C7.27331 18.5625 3.38147 13.6053 2.24494 11.9992C3.37936 10.3919 7.26122 5.4375 12 5.4375C16.7264 5.4375 20.618 10.394 21.7551 12.0007C20.6206 13.6081 16.7388 18.5625 12 18.5625Z"
                                  fill="#ffffff"
                                />
                              </svg>
                            </Link>
                            <button
                              onClick={() => {
                                setIsDelete(true);
                                setSelectedPractices(practice);
                              }}
                              title="Delete"
                              type="button"
                              className="pl-2 pr-5 py-2 text-sm font-medium bg-transparent rounded-e-full"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z"
                                  fill="white"
                                ></path>
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr
                        key={index * 2 + 1}
                        className={`practitioner-table-row ${
                          openIndex === index ? "" : "hidden"
                        }`}
                      >
                        <td className="px-3"></td>
                        <td className="px-3" colSpan="9">
                          <div>
                            <table className="w-full">
                              <thead className="bg-[#f8f8f8] border-b-2 border-green border-solid">
                                <tr>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start w-[90px]">
                                    Photo
                                  </th>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start ">
                                    Practitioner Name
                                  </th>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start">
                                    Category
                                  </th>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start min-w-[90px] sm:w-[134px]">
                                    Reviews
                                  </th>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start min-w-[90px] sm:w-[134px]">
                                    Enquiries
                                  </th>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start ">
                                    Status
                                  </th>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start ">
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {practice?.practitioners?.length > 0 ? (
                                  <>
                                    {practice?.practitioners?.map(
                                      (practitioner, practitionerIndex) => (
                                        <tr key={practitionerIndex}>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            {practitioner.image ? (
                                              <img
                                                src={
                                                  practitioner.image
                                                    ? API_BASE_URL +
                                                      practitioner.image
                                                    : null
                                                }
                                                alt=""
                                                srcSet=""
                                                className="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px] rounded"
                                              />
                                            ) : (
                                              <div className="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px] rounded bg-gray-200 flex items-center justify-center text-lg overflow-hidden font-semibold text-gray-700">
                                                {getInitials(
                                                  practitioner?.practice_name
                                                )}
                                              </div>
                                            )}
                                          </td>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            {practitioner?.practice_name}
                                          </td>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            <span className="text-dark text-base font-medium">
                                              {(() => {
                                                const serviceNames =
                                                  practitioner?.services
                                                    ?.map(
                                                      (service) => service.name
                                                    )
                                                    .join(", ");
                                                return serviceNames.length > 50
                                                  ? serviceNames.slice(0, 50) +
                                                      "..."
                                                  : serviceNames;
                                              })()}
                                            </span>
                                          </td>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            <Link
                                              to={`/admin/reviews/${encryptData(
                                                practitioner?.practices_id
                                              )}`}
                                              className="text-center text-base font-medium text-dark rounded-full block p-1 bg-[#FBFB87] max-w-[110px] w-full"
                                            >
                                              {practitioner?.reviews_count}
                                            </Link>
                                          </td>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            <Link
                                              to={`/admin/enquiries/${encryptData(
                                                practitioner?.practices_id
                                              )}`}
                                              className="text-center text-base font-medium text-dark rounded-full block p-1 bg-[#FBFB87] max-w-[110px] w-full"
                                            >
                                              {
                                                practitioner?.total_enquiries_count
                                              }
                                            </Link>
                                          </td>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            <label
                                              className="inline-flex items-center me-5 cursor-pointer"
                                              onClick={() => {
                                                setIsStatus(true);
                                                setSelectedPractices(
                                                  practitioner
                                                );
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                value=""
                                                className="sr-only peer hidden"
                                                checked={
                                                  practitioner?.status === 1
                                                }
                                                id="toggleSwitch"
                                              />
                                              <div className="relative w-12 h-7 bg-red-50 border-2 border-red-500 rounded-full peer peer-checked:border-green peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-red-500 peer-checked:after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green"></div>
                                            </label>
                                          </td>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            <div
                                              className="flex rounded-full shadow-xs bg-lightblue max-w-[144px] w-full"
                                              role="group"
                                            >
                                              <Link
                                                title="Edit"
                                                to={`/admin/practices-practitioners-edit/${encryptData(
                                                  practitioner?.practices_id
                                                )}/${encryptData(
                                                  practice?.fk_pricing_plan_id
                                                )}`}
                                                className="pl-5 pr-2 py-2 text-sm font-medium  bg-transparent rounded-s-full"
                                              >
                                                <svg
                                                  width="24"
                                                  height="24"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M5 18.89H6.41421L15.7279 9.57628L14.3137 8.16207L5 17.4758V18.89ZM21 20.89H3V16.6473L16.435 3.21232C16.8256 2.8218 17.4587 2.8218 17.8492 3.21232L20.6777 6.04075C21.0682 6.43127 21.0682 7.06444 20.6777 7.45496L9.24264 18.89H21V20.89ZM15.7279 6.74786L17.1421 8.16207L18.5563 6.74786L17.1421 5.33364L15.7279 6.74786Z"
                                                    fill="#393939"
                                                  />
                                                </svg>
                                              </Link>
                                              <Link
                                                title="Preview"
                                                target="_blank"
                                                to={`/admin/practices-practitioners-details/${encryptData(
                                                  practitioner?.practices_id
                                                )}`}
                                                className="px-2 py-2 text-sm font-medium  bg-transparent rounded-s-full"
                                              >
                                                <svg
                                                  width="24"
                                                  height="24"
                                                  viewBox="0 0 24 24"
                                                  fill="#393939"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M12 7.3125C9.41527 7.3125 7.3125 9.41531 7.3125 12C7.3125 14.5847 9.41527 16.6875 12 16.6875C14.5847 16.6875 16.6875 14.5847 16.6875 12C16.6875 9.41531 14.5847 7.3125 12 7.3125ZM12 14.8125C10.4492 14.8125 9.1875 13.5508 9.1875 12C9.1875 10.4492 10.4492 9.1875 12 9.1875C13.5508 9.1875 14.8125 10.4492 14.8125 12C14.8125 13.5508 13.5508 14.8125 12 14.8125Z"
                                                    fill="#393939"
                                                  />
                                                  <path
                                                    d="M23.691 11.5042C22.7717 10.0288 18.0932 3.5625 12 3.5625C5.90812 3.5625 1.22841 10.0287 0.308953 11.5042L0 12L0.308953 12.4958C1.22831 13.9712 5.90677 20.4375 12 20.4375C18.0919 20.4375 22.7716 13.9713 23.691 12.4958L24 12L23.691 11.5042ZM12 18.5625C7.27331 18.5625 3.38147 13.6053 2.24494 11.9992C3.37936 10.3919 7.26122 5.4375 12 5.4375C16.7264 5.4375 20.618 10.394 21.7551 12.0007C20.6206 13.6081 16.7388 18.5625 12 18.5625Z"
                                                    fill="#393939"
                                                  />
                                                </svg>
                                              </Link>
                                              <button
                                                onClick={() => {
                                                  setIsDelete(true);
                                                  setSelectedPractices(
                                                    practitioner
                                                  );
                                                }}
                                                title="Delete"
                                                type="button"
                                                className="pl-2 pr-5 py-2 text-sm font-medium  bg-transparent rounded-e-full deletebtn"
                                              >
                                                <svg
                                                  width="24"
                                                  height="24"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z"
                                                    fill="#393939"
                                                  />
                                                </svg>
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </>
                                ) : (
                                  <tr className="Practice-table-row">
                                    <td
                                      colSpan={6}
                                      className="py-2 px-1.5 sm:py-4 sm:px-3 text-center"
                                    >
                                      No Practitioners Found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                ) : (
                  <tr className="Practice-table-row">
                    <td
                      colSpan={10}
                      className="text-center py-2 px-1.5 sm:py-4 sm:px-3 border-y-2 border-solid border-[#dfdfdf]"
                    >
                      No Practices Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {paginatedData?.length > 0 && (
            <div className="px-3 py-3 border-t-2 border-solid border-[#dfdfdf]">
              <ul className="flex items-center -space-x-px h-10 text-base justify-end">
                {/* Previous Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`flex items-center justify-center px-4 h-10 ms-0 leading-tight border border-e-0 rounded-s-lg border-[#73aeff] 
          ${
            currentPage === 1
              ? "text-gray-400 bg-gray-200 cursor-not-allowed"
              : "text-blue bg-gray-200 hover:bg-gray-100"
          }`}
                  >
                    <svg
                      className="w-3 h-3 rtl:rotate-180"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 6 10"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 1 1 5l4 4"
                      ></path>
                    </svg>
                  </button>
                </li>

                {/* Dynamic Pagination Logic */}
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter((page) => {
                    return (
                      page === 1 ||
                      page === totalPages ||
                      (page >= currentPage - 1 && page <= currentPage + 1)
                    );
                  })
                  .reduce((acc, page, index, arr) => {
                    if (index > 0 && page !== arr[index - 1] + 1) {
                      acc.push("...");
                    }
                    acc.push(page);
                    return acc;
                  }, [])
                  .map((page, index) => (
                    <li key={index}>
                      {page === "..." ? (
                        <span
                          className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] bg-gray-200 text-blue`}
                        >
                          ...
                        </span>
                      ) : (
                        <button
                          onClick={() => handlePageChange(page)}
                          className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] 
                ${
                  currentPage === page
                    ? "bg-white text-blue"
                    : "bg-gray-200 text-blue hover:bg-gray-100"
                }`}
                        >
                          {page}
                        </button>
                      )}
                    </li>
                  ))}

                {/* Next Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`flex items-center justify-center px-4 h-10 leading-tight border rounded-e-lg border-[#73aeff] 
          ${
            currentPage === totalPages
              ? "text-gray-400 bg-gray-200 cursor-not-allowed"
              : "text-blue bg-gray-200 hover:bg-gray-100"
          }`}
                  >
                    <svg
                      className="w-3 h-3 rtl:rotate-180"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 6 10"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 9 4-4-4-4"
                      ></path>
                    </svg>
                  </button>
                </li>
              </ul>
            </div>
          )}

          <div
            id="deletepopup"
            className={`fixed bg-[#0000007A] top-0 left-0 h-screen w-full z-[999] justify-center items-center px-3 ${
              isDelete ? "flex" : "hidden"
            }`}
          >
            <div className="max-w-[630px] w-full mx-auto bg-white rounded-xl sm:rounded-2xl px-3 py-6 sm:py-10 sm:px-10 lg:px-20 innercard">
              <div className="max-w-[312px] w-full flex justify-center items-center gap-6 flex-col mx-auto">
                <svg
                  width="72"
                  height="72"
                  viewBox="0 0 72 72"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M36 66C19.4314 66 6 52.5684 6 36C6 19.4314 19.4314 6 36 6C52.5684 6 66 19.4314 66 36C66 52.5684 52.5684 66 36 66ZM36 60C49.2549 60 60 49.2549 60 36C60 22.7452 49.2549 12 36 12C22.7452 12 12 22.7452 12 36C12 49.2549 22.7452 60 36 60ZM36 31.7574L44.4852 23.2721L48.7278 27.5147L40.2426 36L48.7278 44.4852L44.4852 48.7278L36 40.2426L27.5147 48.7278L23.2721 44.4852L31.7574 36L23.2721 27.5147L27.5147 23.2721L36 31.7574Z"
                    fill="#FF5252"
                  />
                </svg>

                {/* info  */}
                {/* <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M36 0C16.1496 0 0 16.1498 0 36.0002C0 55.8506 16.1496 72 36 72C55.8504 72 72 55.8506 72 36.0002C72 16.1498 55.8504 0 36 0ZM36 65.4545C19.7585 65.4545 6.54545 52.2415 6.54545 36.0002C6.54545 19.759 19.7585 6.54545 36 6.54545C52.2415 6.54545 65.4545 19.759 65.4545 36.0002C65.4545 52.2415 52.2412 65.4545 36 65.4545Z" fill="#0052CC" />
                                    <path d="M35.9996 15.2734C33.5939 15.2734 31.6368 17.2318 31.6368 19.639C31.6368 22.0441 33.5939 24.0007 35.9996 24.0007C38.4053 24.0007 40.3624 22.0441 40.3624 19.639C40.3624 17.2318 38.4053 15.2734 35.9996 15.2734Z" fill="#0052CC" />
                                    <path d="M36 30.5449C34.1926 30.5449 32.7273 32.0102 32.7273 33.8176V53.454C32.7273 55.2614 34.1926 56.7267 36 56.7267C37.8074 56.7267 39.2727 55.2614 39.2727 53.454V33.8176C39.2727 32.0102 37.8074 30.5449 36 30.5449Z" fill="#0052CC" />
                                </svg> */}

                {/* success  */}
                {/* <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M36 0C16.1484 0 0 16.1484 0 36C0 55.8516 16.1484 72 36 72C55.8516 72 72 55.8488 72 36C72 16.1512 55.8516 0 36 0ZM36 66.423C19.227 66.423 5.57705 52.7759 5.57705 36C5.57705 19.2241 19.227 5.57705 36 5.57705C52.7759 5.57705 66.423 19.2241 66.423 36C66.423 52.7759 52.773 66.423 36 66.423Z" fill="#00A167" />
                                    <path d="M52.5165 23.4788C51.3815 22.4471 49.6164 22.5279 48.5792 23.6684L31.569 42.3991L23.3512 34.0447C22.2664 32.946 20.5041 32.9292 19.4082 34.0112C18.3095 35.0904 18.2928 36.8555 19.3747 37.9542L29.6616 48.4112C30.1887 48.9466 30.9025 49.245 31.6497 49.245C31.6665 49.245 31.686 49.245 31.7028 49.2478C32.4724 49.2311 33.1975 48.902 33.7133 48.3332L52.706 27.4191C53.7407 26.2757 53.657 24.5134 52.5165 23.4788Z" fill="#00A167" />
                                </svg> */}

                <h4 className="text-center font-bold text-xl mg:text-2xl text-blue">
                  Are you sure! <br />
                  you want to Delete?
                </h4>
                <div className="flex justify-between gap-3 w-full">
                  <button
                    type="button"
                    onClick={() => {
                      setIsDelete(false);
                      setSelectedPractices(null);
                    }}
                    className="bg-transparent text-center text-dark text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-dark cancelbtn"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleDelete}
                    className="bg-blue text-center text-white text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-blue deletebtn"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            id="statuspopup"
            className={`fixed bg-[#0000007A] top-0 left-0 h-screen w-full z-[999] justify-center items-center px-3 ${
              isStatus ? "flex" : "hidden"
            }`}
          >
            <div className="max-w-[630px] w-full mx-auto bg-white rounded-xl sm:rounded-2xl px-3 py-6 sm:py-10 sm:px-10 lg:px-20 innercard">
              <div className="max-w-[312px] w-full flex justify-center items-center gap-6 flex-col mx-auto">
                <svg
                  width="72"
                  height="72"
                  viewBox="0 0 72 72"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M36 0C16.1496 0 0 16.1498 0 36.0002C0 55.8506 16.1496 72 36 72C55.8504 72 72 55.8506 72 36.0002C72 16.1498 55.8504 0 36 0ZM36 65.4545C19.7585 65.4545 6.54545 52.2415 6.54545 36.0002C6.54545 19.759 19.7585 6.54545 36 6.54545C52.2415 6.54545 65.4545 19.759 65.4545 36.0002C65.4545 52.2415 52.2412 65.4545 36 65.4545Z"
                    fill="#0052CC"
                  />
                  <path
                    d="M35.9996 15.2734C33.5939 15.2734 31.6368 17.2318 31.6368 19.639C31.6368 22.0441 33.5939 24.0007 35.9996 24.0007C38.4053 24.0007 40.3624 22.0441 40.3624 19.639C40.3624 17.2318 38.4053 15.2734 35.9996 15.2734Z"
                    fill="#0052CC"
                  />
                  <path
                    d="M36 30.5449C34.1926 30.5449 32.7273 32.0102 32.7273 33.8176V53.454C32.7273 55.2614 34.1926 56.7267 36 56.7267C37.8074 56.7267 39.2727 55.2614 39.2727 53.454V33.8176C39.2727 32.0102 37.8074 30.5449 36 30.5449Z"
                    fill="#0052CC"
                  />
                </svg>

                <h4 className="text-center font-bold text-xl mg:text-2xl text-blue">
                  Are you sure! <br />
                  you want to change status?
                </h4>
                <div className="flex justify-between gap-3 w-full">
                  <button
                    type="button"
                    onClick={() => {
                      setIsStatus(false);
                      setSelectedPractices(null);
                    }}
                    className="bg-transparent text-center text-dark text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-dark cancelbtn"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleStatusChange}
                    className="bg-blue text-center text-white text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-blue deletebtn"
                  >
                    Change
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>

        <div
          id="isBillingPopModel"
          class={`fixed z-[999] inset-0 items-center justify-center bg-black bg-opacity-50 px-3 ${
            isBillingModel === true ? "flex" : "hidden"
          }`}
        >
          <div className="emailbox bg-white p-9 rounded-lg shadow-lg w-full max-w-[512px] relative max-h-[90vh]">
            <button
              type="button"
              class="absolute right-4 top-4"
              onClick={(e) => setIsBillingModel(false)}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.41791 0.436139C0.685579 0.168311 1.04857 0.0178675 1.42704 0.0178675C1.80551 0.0178675 2.1685 0.168311 2.43617 0.436139L9.99103 7.99754L17.5459 0.436139C17.6777 0.299682 17.8351 0.190853 18.0092 0.115982C18.1834 0.0411107 18.3708 0.00171073 18.5602 5.3593e-05C18.7497 -0.00158926 18.9377 0.0345535 19.1131 0.106382C19.2886 0.17821 19.4479 0.284296 19.5819 0.418424C19.7159 0.552553 19.822 0.712052 19.8938 0.887623C19.9654 1.06319 20.0015 1.25131 19.9999 1.44099C19.9982 1.63068 19.9588 1.81814 19.884 1.99242C19.8093 2.16671 19.7005 2.32435 19.5642 2.45612L12.0093 10.0175L19.5642 17.5789C19.8242 17.8484 19.9681 18.2092 19.9648 18.5838C19.9616 18.9584 19.8115 19.3167 19.5468 19.5815C19.2821 19.8464 18.9242 19.9967 18.5499 19.9999C18.1757 20.0032 17.8151 19.8592 17.5459 19.5989L9.99103 12.0375L2.43617 19.5989C2.16697 19.8592 1.80643 20.0032 1.43218 19.9999C1.05793 19.9967 0.699938 19.8464 0.435296 19.5815C0.170653 19.3167 0.0205397 18.9584 0.0172997 18.5838C0.0140454 18.2092 0.157906 17.8484 0.41791 17.5789L7.97277 10.0175L0.41791 2.45612C0.150327 2.18824 0 1.82494 0 1.44612C0 1.06732 0.150327 0.704024 0.41791 0.436139Z"
                  fill="black"
                ></path>
              </svg>
            </button>
            <div
              id="emailthankYouSection"
              className={`items-center justify-center flex-col ${
                isBillingModel === true ? "flex" : "hidden"
              }`}
            >
              <p className="text-[26px] leading-normal font-bold text-center text-blue mb-6">
                Practice creation limit reached for free listing.
              </p>
              <p className="text-xl font-light text-center text-dark">
                Please upgrade the plan to add more listings.
              </p>
              <Link
                to={"/admin/billing"}
                class="h-auto py-3 px-3 sm:h-14 bg-blue w-full text-center text-white font-semibold text-lg sm:text-2xl rounded-xl mb-4 sm:mb-4 mt-3"
              >
                Go To Billing
              </Link>
            </div>
          </div>
        </div>
      </AdminLayout>
    </>
  );
};

export default AdminHomePage;
